const HAND_OFF = /(?:^#|&)hand-off=([^&]+)/;
const REFUSAL_KEY = "signInHandOffRefusal";

/**
 * The code the account area opened the hub with, taken out of the address straight away so it
 * isn't left in the history or a shared link (F2 in prd/platform/self-service.md)
 */
export const takeSignInHandOffCode = () => {
    const code = HAND_OFF.exec(window.location.hash)?.[1];

    if (code) {
        window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search);
    }

    return code ? decodeURIComponent(code) : null;
};

/** Kept for the sign-in screen, which the hub shows next to anybody not signed in */
export const rememberSignInHandOffRefusal = (refusal: string) => sessionStorage.setItem(REFUSAL_KEY, refusal);

/** Read once, so it isn't shown again on the next visit to sign-in */
export const takeSignInHandOffRefusal = () => {
    const refusal = sessionStorage.getItem(REFUSAL_KEY);

    sessionStorage.removeItem(REFUSAL_KEY);

    return refusal;
};
